import { PlatformEnum, type PlatformContextConfig } from './platformContextTypes';

class PlatformContextService {
  private config: PlatformContextConfig = {
    platform: PlatformEnum.WEB,
    paymentEmitterPlatform: undefined,
  };

  private getCorrectPlatform(input: string | null): PlatformEnum {
    switch (input) {
      case PlatformEnum.APP_IOS:
      case PlatformEnum.APP_ANDROID:
      case PlatformEnum.WEB:
        return input;
      default:
        return PlatformEnum.WEB;
    }
  }

  public initFromURL(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const platformParam = urlParams.get('platform');
    const paymentEmitterPlatformParam = urlParams.get('paymentEmitterPlatform');

    this.setConfig(
      this.getCorrectPlatform(platformParam),
      paymentEmitterPlatformParam ? this.getCorrectPlatform(paymentEmitterPlatformParam) : undefined,
    );
  }

  private setConfig(platform: PlatformEnum, paymentEmitterPlatform?: PlatformEnum): void {
    this.config.platform = platform;
    this.config.paymentEmitterPlatform = paymentEmitterPlatform;
  }

  public getConfig(): PlatformContextConfig {
    return this.config;
  }
}

export const platformContextService = new PlatformContextService();
